import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'

export default createUseStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    padding: [52, 16, 24],
    minHeight: '100%',
    boxSizing: 'border-box',
    [forPhoneOnly]: {
      padding: [32, 16, 24],
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: 477,
    maxWidth: 477,
  },
  title: {
    marginBottom: 24,
    textAlign: 'center',
    ...typography['Lato H4 Bold'],
    [forPhoneOnly]: {
      ...typography['Lato H5 Bold'],
    },
  },
  calendarButtonContainer: {
    marginTop: 16,
    marginBottom: 16,
  },
})
